import { render, staticRenderFns } from "./MobileNotifications.vue?vue&type=template&id=d1f29d20&scoped=true&"
import script from "./MobileNotifications.vue?vue&type=script&lang=ts&"
export * from "./MobileNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNotifications.vue?vue&type=style&index=0&id=d1f29d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f29d20",
  null
  
)

export default component.exports